<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="py-5" elevation="8">
          <h1
            class="text-center primary--text text-h4"
            style="font-family: Kelly Slab !important"
          >
            Planos para o CPF/CNPJ {{ $store.state.cpf }}
          </h1>
          <h4 class="text-center">
            Data:
            {{
              new Date()
                .getDate()
                .toString()
                .padStart(2, "0")
            }}/ {{ (new Date().getMonth() + 1).toString().padStart(2, "0") }}/
            {{ new Date().getFullYear() }}
          </h4>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="fill-height">
      <v-col
        xs="12"
        v-for="(item, i) in ofertas"
        :key="i"
        class="d-flex flex-column"
      >
        <v-card class="mx-auto d-flex flex-column flex-grow-1" max-width="344">
          <v-list-item three-line class="flex-grow-1">
            <v-list-item-content>
              <div
                class="overline mb-2"
                style="font-family: Kelly Slab !important"
              >
                {{ credor }}
              </div>
              <v-list-item-subtitle class="mb-1">
                <div class="text--primary">
                  <b> Desconto de </b>
                </div>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="mb-1">
                <div class="text--primary">
                  {{ Math.trunc((item.DiscountRate * 100).toFixed(2)) }}%
                </div>
              </v-list-item-subtitle>
              <v-list-item-title class="headline mb-1">{{
                item.DownPaymentAmount == 0 ? "A Vista" : "Parcelado"
              }}</v-list-item-title>
              <v-list-item-subtitle class="mb-1">
                <div class="text--primary" v-if="item.DownPaymentAmount > 0">
                  Entrada de R$ <b>{{ item.DownPaymentAmount | dinheiro }}</b>
                </div>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="mb-1">
                <div class="text--primary" v-if="item.DownPaymentAmount > 0">
                  +
                </div>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="mb-1">
                <div class="text--primary">
                  {{ item.TotalInstallments }}X de R$
                  <b>{{ item.InstallmentAmount | dinheiro }}</b>
                </div>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="mb-1">
                <div class="text--primary">
                  Venc: <b> {{ item.ScheduleDate | dataF }} </b>
                </div>
              </v-list-item-subtitle>

              <!--  <v-list-item-subtitle class="mb-1">
                <div class="text--primary">
                  R$ {{ item.ArrangementDiscount | dinheiro }}
                </div>
              </v-list-item-subtitle> -->
            </v-list-item-content>
          </v-list-item>
          <v-card-actions class="mt-auto">
            <v-btn color="primary" @click="negociar(i)">
              Negociar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <!--  -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { api } from "@/conf/api";
//import {calcDescViasat} from "@/conf/utilitario";

export default {
  name: "PlanoDivZero",
  data() {
    return {
      credor: "DIVZERO",
      ofertas: null,
      divida: {},
      overlay: false,
      contrato: null,
      cpf: null,
    };
  },
  filters: {
    dinheiro: function(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(".", ",");
    },
    dataF: function(d2) {
      let d = d2.substr(0, 10);
      return d.substr(8, 2) + "/" + d.substr(5, 2) + "/" + d.substr(0, 4);
    },
  },
  async beforeMount() {
    //console.log("entrou no before mount do plano divzero");
    this.credor = this.$store.state.credor_atual;
    this.divida = this.$store.state.divida_atual;
    console.log("divida atual", this.divida);
    let contrato = this.divida.contrato;
    let cpf = this.$store.state.cpf;
    this.contrato = contrato;
    this.cpf = cpf;
    let divzero = this.$store.state.dividas_divzero;
    let divida1 = divzero.filter(function(item) {
      return item.DebtNumber == contrato;
    });

    this.ofertas = divida1[0].ofertas;

    //console.log("ofertas", contrato, this.ofertasCliente);
  },

  methods: {
    abrirPdfBase64(base64) {
      // Se vier com prefixo: data:application/pdf;base64,...
      const base64Limpo = base64.replace(/^data:application\/pdf;base64,/, "");

      const byteCharacters = atob(base64Limpo);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], {
        type: "application/pdf",
      });

      const url = URL.createObjectURL(blob);

      window.open(url, "_blank");

      // opcional: limpar depois
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    },
    async negociar(index) {
      try {
        this.overlay = true;
        await this.$store.dispatch("marcaPacoteAtual", "divzero");
        console.log("of", this.ofertas[index]);
        let rep1 = await api.post(
          "divzero/negociar/" + this.cpf + "/site",
          this.ofertas[index],
        );

        let rep2 = rep1.data;
        console.log("rep2", rep2);
        let boleto = await api.get("divzero/pegaboleto/" + this.cpf);
        // console.log("rep2", JSON.stringify(boleto, null, 2));
        //alert(index);
        this.abrirPdfBase64(boleto.data.NextInstallments[0].BilletPdfContent);
        // this.$router.push(this.$store.state.divida_atual.cpcgc);
        //this.$router.push("PlanoUnismg2");
        this.overlay = false;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style></style>
